import { TypedDocumentNode, gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

import {
    OrganizationMaxServicesPerAppointmentQueryQuery,
    OrganizationMaxServicesPerAppointmentQueryQueryVariables,
} from './useMaxServicesPerAppointment.gql.types';

const ORGANIZATION_MAX_SERVICES_PER_APPOINTMENT_QUERY: TypedDocumentNode<
    OrganizationMaxServicesPerAppointmentQueryQuery,
    OrganizationMaxServicesPerAppointmentQueryQueryVariables
> = gql`
    query OrganizationMaxServicesPerAppointmentQuery {
        currentOrganization {
            id
            config {
                id
                maxServicesPerAppointment
            }
        }
    }
`;

// Non-suspending: exposes loading so callers render their own loading state.
export const useMaxServicesPerAppointment = (): {
    data: number | null | undefined;
    loading: boolean;
} => {
    const { data, loading } = useQuery(ORGANIZATION_MAX_SERVICES_PER_APPOINTMENT_QUERY);

    return { data: data?.currentOrganization?.config.maxServicesPerAppointment, loading };
};
